var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-success is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"column is-6 is-offset-3"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }